<template>
    <v-form
        ref="form"
        class="mt-4"
        lazy-validation v-on:submit.prevent
    >

        <!-- <div
            class="mb-4"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
            >
                姓名
            </h3>
            <v-row
            >
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="pb-0"
                >
                    <v-text-field
                        v-model="data.name"
                        dense
                        outlined
                        placeholder="王小明"
                        :maxlength="30"
                        :rules="[$utils.field_rules.required]"
                    ></v-text-field>
                </v-col>

            </v-row>
        </div>

        <div
            class="mb-4"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
            >
                信箱
            </h3>
            <v-row
            >
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="pb-0"
                >
                    <v-text-field
                        ref="email_input"
                        v-model="data.email"
                        dense
                        outlined
                        placeholder="abc@example.com"
                        :rules="[$utils.field_rules.email, $utils.field_rules.required]"
                    ></v-text-field>
                </v-col>

            </v-row>
        </div>                 -->

        <div class="mb-4">
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
            >
                發票號碼
            </h3>
            <v-row
            >

                
                <v-col
                    cols="4"
                    lg="4"
                    md="4"
                    sm="4"
                    class="pb-0"
                >
                    <v-text-field
                        v-model="data.prefix"
                        dense
                        outlined
                        placeholder="AA"
                        :maxlength="2"
                        hide-details
                        :rules="[$utils.field_rules.onlyEng, $utils.field_rules.required]"
                        @input="handleInputPrefix"
                    ></v-text-field>
                </v-col>
                <!-- <v-col
                    cols="1"
                    lg="1"
                    md="1"
                    sm="1"
                    class="d-flex pt-5 pb-0 justify-center"
                >
                    <span>—</span>
                </v-col> -->
                

                <v-col
                    cols="8"
                    lg="8"
                    md="8"
                    sm="8"
                    class="pb-0"
                >
                    <v-text-field
                        ref="number_input"
                        v-model="data.number"
                        dense
                        outlined
                        class="invoice-input"
                        placeholder="12345678"
                        :maxlength="8"
                        type="text"
                        :rules="[$utils.field_rules.isOnlyNumber, $utils.field_rules.required]"
                        @input="handleInputNumber"
                    ></v-text-field>
                </v-col>

            </v-row>
        </div>

        <div
            class="mb-4"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
            >
                消費日期
            </h3>
            <v-row
            >
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                >
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :key="date_key"
                            v-model="data.create_at"
                            ref="create_input"
                            placeholder="YYYY-MM-DD"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense
                            outlined
                            :rules="[$utils.field_rules.required, $utils.field_rules.date]"
                            @input="handleInputDate"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="data.create_at"
                            @input="menu2 = false"
                            locale="zh-tw"
                        ></v-date-picker>
                    </v-menu>

                    <!-- <v-text-field
                        :key="date_key"
                        v-model="data.create_at"
                        ref="create_input"
                        dense
                        outlined
                        placeholder="YYYY-MM-DD"
                        :maxlength="15"
                        :rules="[$utils.field_rules.required, $utils.field_rules.date]"
                        @input="handleInputDate"

                    ></v-text-field> -->
                </v-col>

            </v-row>
        </div>

        <div
            class="mb-3"
            v-if="setting.value_method === 'cost'"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
                
            >
                消費金額
            </h3>
            <v-row
            >
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="pb-0"
                >
                    <v-text-field
                        ref="random_number_input"
                        v-model="data.value"
                        dense
                        outlined
                        placeholder="100"
                        :value="data.value"
                        :rules="[$utils.field_rules.isOnlyNumber, $utils.field_rules.required]"
                    ></v-text-field>
                </v-col>

            </v-row>
        </div>
        <div
            class="mb-3"
            v-if="setting.value_method === 'item'"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
                
            >
                購買項目
            </h3>
            
            <v-row
                v-for="(item, idx) in data.items"
                :key="idx"
                class="d-flex align-center"
            >

                <v-col
                    cols="10"
                    lg="10"
                    md="10"
                    sm="10"
                    class="pb-0 pr-0"
                >

                    <div>
                        <div>
                            <v-text-field
                                v-model="item.name"
                                dense
                                outlined
                                placeholder="商品名稱"
                                :value="item.name"
                                :rules="[$utils.field_rules.required]"
                            ></v-text-field>
                        </div>

                        <div
                            class="d-flex"
                        >
                            <v-text-field
                                v-model="item.quantity"
                                dense
                                outlined
                                class="invoice-input mr-3"
                                placeholder="數量"
                                type="text"
                                :rules="[$utils.field_rules.isOnlyNumber, $utils.field_rules.required]"
                            ></v-text-field>

                            <v-text-field
                                v-model="item.per_price"
                                dense
                                outlined
                                class="invoice-input"
                                placeholder="單價"
                                type="text"
                                :rules="[$utils.field_rules.isOnlyNumber, $utils.field_rules.required]"
                            ></v-text-field>
                        </div>
                    </div>



                </v-col>
                <v-col
                    cols="2"
                    lg="2"
                    md="2"
                    sm="2"
                    class="pb-0 pl-0"
                >
                    <v-btn
                        icon
                        small
                        @click="delItem(idx)"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                        
                    </v-btn>
                </v-col>
            </v-row>
            <div
                class="mt-3"
            >
                <v-btn
                    :color="setting.theme_color"
                    class="pl-10 pr-10 white--text"
                    @click="addItem"
                >

                    新增項目
                </v-btn>
            </div>
        </div>

        <!-- <div
            class="mb-3"
        >
            <h3
                style="text-align:left;"
                :style="{
                    'color': setting.theme_color
                }"
                class="mb-2"
                
            >
                上傳圖檔
            </h3>
            <v-row
            >
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                >

                    <v-card
                        width="160px"
                        height="250px"
                        color="#d1d1d1"
                        max-width="250px"
                        class="d-flex align-center justify-center flex-column"
                    >

                        <v-btn
                            color="#FFFFFF"
                            fab
                            small
                            class="mb-4"
                            @click="uploadImage"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>


                        <h6>點擊上傳圖片</h6>

                        <input
                            ref="uploader"
                            class="d-none"
                            type="file"
                            accept="image/*"
                            @change="onFileChanged"
                        >
                    </v-card>
                </v-col>

            </v-row>
        </div> -->
    </v-form>
</template>

<script>
    export default {
        name: 'InvoiceForm',
        props: {
            setting: Object,
        },
        components: {
        },
        data: function(){
            return {
                data: {
                    scan: {},
                    prefix: '',
                    number: '',
                    create_at: '',
                    display_create_at: '12',
                    random_number: '',
                    name: '',
                    email: '',
                    items: [],
                },
                date_key: 1,
                menu2: false
            }
        },
        created: async function(){
        },
        mounted: function(){
            this.data = this.setting.data
        },
        methods: {
            handleInputPrefix(){
                console.log(this.data.prefix)
                if (this.data.prefix.length >= 2) {
                    this.$refs.number_input.focus();
                }
            },
            handleInputNumber(){

            },
            handleInputDate(event){
                console.log('event',event)
                // this.data.create_at = this.formatDate(this.data.create_at)
            },
            uploadImage(){
                
                console.log(this.$refs.image_input)
            },
            validateInput(){
                let result = this.$refs.form.validate()
                return result
            },
            formatDate(date_string){
                console.log('date_string', date_string)
                console.log('date_string', date_string.length)
                let output = ''
                if (date_string.length <= 4) {
                    output += date_string.substring(0,4)

                    let fill_count = 4 - date_string.substring(0,4).length
                    for (let idx = 0; idx < fill_count; idx++) {
                        if (idx === fill_count - 1) {
                            output += '_';
                        }
                        else {
                            output += '_ ';
                        }
                    }
                }
                output += '-'
                if (date_string.length <= 6) {
                    output += date_string.substring(4, 2)
                    let fill_count = 2 - date_string.substring(4,2).length
                    for (let idx = 0; idx < fill_count; idx++) {
                        if (idx === fill_count - 1) {
                            output += '_';
                        }
                        else {
                            output += '_ ';
                        }
                    }
                }
                output += '-'

                if (date_string.length <= 8) {
                    output += date_string.substring(6, 2)
                    let fill_count = 2 - date_string.substring(6,2).length
                    for (let idx = 0; idx < fill_count; idx++) {
                        if (idx === fill_count - 1) {
                            output += '_';
                        }
                        else {
                            output += '_ ';
                        }
                    }
                }
                console.log('output',output)
                return output
    
            },
            addItem(){
                let item = {
                    "quantity": "",
                    "name": "",
                    "per_price": ""
                }
                this.data.items.push(item)
            },
            delItem(idx){
                this.data.items.splice(idx,1)
            }
        }
    }
</script>
<style scoped></style>